const paths = {
  home: "M3 10 12 3l9 7M5 9v12h5v-7h4v7h5V9",
  calendar: "M4 5h16v16H4zM4 9h16M8 3v4M16 3v4M8 13h2M14 13h2M8 17h2M14 17h2",
  shopping: "M3 4h2l3 12h10l3-9H6M9 20h.01M18 20h.01",
  inbox: "M4 4h16v16H4zM4 14h5l1 3h4l1-3h5",
  settings: "M4 7h16M4 17h16M8 4v6M16 14v6",
  mic: "M9 6a3 3 0 0 1 6 0v6a3 3 0 0 1-6 0zM6 11v1a6 6 0 0 0 12 0v-1M12 18v3M9 21h6",
  pin: "M12 21s-6-5.6-6-11a6 6 0 0 1 12 0c0 5.4-6 11-6 11zM12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
} as const;

export function Icon({ name }: { name: keyof typeof paths }) {
  return <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={paths[name]} /></svg>;
}
